import type { Middleware } from '@reduxjs/toolkit';
import { isRejectedWithValue } from '@reduxjs/toolkit';

import { snackbar, getFriendlyMessageForApis } from '@/_shared';

const rtkQueryErrorLogger: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    try {
      if (action.payload?.data?.code !== 'token_not_valid') {
        const { msg } = getFriendlyMessageForApis(action.payload, action?.error);

        // hardship check
        if (msg && msg !== 'You are allowed to accept hardship only once in a year.') {
          snackbar.error(msg, { toastId: msg });
        }
      }
    } catch (e) {
      console.log(e);
      const msg = 'catch: System failure, Please contact support team.';
      snackbar.error(msg, { toastId: msg });
    }
  }

  return next(action);
};

export default rtkQueryErrorLogger;
